import { css } from '@emotion/react';

export const root = css``;

export const header = css`
  margin-bottom: 2.4rem;
`;

export const headerInner = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const headerBlock = css`
  display: flex;
  align-items: center;
`;

export const back = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  background: var(--color-white);
  border-radius: 0.4rem;
  border: 1px solid var(--color-foreground-sub);
  margin-right: 1.6rem;
  &:hover {
    background: var(--color-background-light);
    color: inherit;
  }
`;

export const heading = css`
  font-size: 2.5rem;
  font-weight: 700;
`;

export const lead = css`
  margin-top: 1.6rem;
`;

export const block = (spacing: { horizontal?: number; vertical?: number }) => css`
  /* padding: 4rem; */
  background: var(--color-white);
  border-radius: 0.8rem;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  padding-top: ${spacing.vertical !== undefined ? `${spacing.vertical / 10}rem` : '4rem'};
  padding-bottom: ${spacing.vertical !== undefined ? `${spacing.vertical / 10}rem` : '4rem'};
  padding-right: ${spacing.horizontal !== undefined ? `${spacing.horizontal / 10}rem` : '4rem'};
  padding-left: ${spacing.horizontal !== undefined ? `${spacing.horizontal / 10}rem` : '4rem'};
`;

export const blockHeader = css`
  margin-bottom: 2.4rem;
`;

export const blockHeading = css`
  font-size: 2.1rem;
  font-weight: 700;
`;

export const blockLead = css`
  margin-top: 0.8rem;
`;

export const footer = (display = 'flex') => css`
  display: ${display};
  ${display === 'flex' ? 'align-items: center; justify-content: space-between;' : ''}
  width: 100%;
  margin-top: 2.4rem;
`;

export const buttons = css`
  display: flex;
  gap: 2.4rem;
  justify-content: flex-start;
`;
